import { Product } from '../types';

// ============================================
// FUSE BOXES - COMPLETE RANGE
// ============================================

// SQUARE FUSE BOXES - TATA / ASHOK LEYLAND / EICHER
export const squareFuseBoxProducts: Product[] = [
  {
    id: "fuse-box-square-60wire",
    name: "Square Fuse Box - 60 Wire (14 Relay)",
    slug: "square-fuse-box-60-wire-14-relay",
    category: "Fuse Boxes",
    subcategory: "Square Fuse Box",
    description: "Square fuse box with 60 wire points (60 point) and 14 relay configuration (56 wire). Heavy duty for commercial vehicles. Made with Saroop Deluxe Wire.",
    partNumber: "SFB5101S",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5101S.jpg",
    featured: true,
    specifications: {
      "Type": "Square Fuse Box",
      "Wire Points": "60 Wire (60 Point)",
      "Relay Configuration": "14 Relay (56 Wire)",
      "Wire Type": "Saroop Deluxe Wire",
      "Application": "Commercial Vehicles",
    },
    tags: ["fuse-box", "square", "60-wire", "14-relay", "heavy-duty"],
    applications: ["Commercial Vehicles", "Heavy Duty Trucks"],
  },
  {
    id: "fuse-box-square-36wire",
    name: "Square Fuse Box - 36 Wire (5 Relay)",
    slug: "square-fuse-box-36-wire-5-relay",
    category: "Fuse Boxes",
    subcategory: "Square Fuse Box",
    description: "Square fuse box with 36 wire points (36 point) and 5 relay configuration (21 wire). Made with Saroop Deluxe Wire.",
    partNumber: "SFB5106S",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5106S.jpg",
    specifications: {
      "Type": "Square Fuse Box",
      "Wire Points": "36 Wire (36 Point)",
      "Relay Configuration": "5 Relay (21 Wire)",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "square", "36-wire", "5-relay"],
    applications: ["Commercial Vehicles", "Medium Duty"],
  },
  {
    id: "fuse-box-square-30wire",
    name: "Square Fuse Box - 30 Wire (4 Relay)",
    slug: "square-fuse-box-30-wire-4-relay",
    category: "Fuse Boxes",
    subcategory: "Square Fuse Box",
    description: "Square fuse box with 30 wire points (30 point) and 4 relay configuration (16 wire). Made with Saroop Deluxe Wire.",
    partNumber: "SFB5108S",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5108S.jpg",
    specifications: {
      "Type": "Square Fuse Box",
      "Wire Points": "30 Wire (30 Point)",
      "Relay Configuration": "4 Relay (16 Wire)",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "square", "30-wire", "4-relay"],
    applications: ["Commercial Vehicles"],
  },
  {
    id: "fuse-box-tata-lpt",
    name: "Tata LPT Fuse Box - Universal (BS II/III/IV)",
    slug: "fuse-box-tata-lpt-universal",
    category: "Fuse Boxes",
    subcategory: "Square Fuse Box",
    description: "Square fuse box suitable for Tata LPT 1613TC / 1616TC / 2515TC / 2518TC / 3118TC / 3718TC / 4018TC / 4018 Horse. Compatible with BS II, BS III, and BS IV standards. Made with Saroop Deluxe Wire.",
    featured: true,
    specifications: {
      "Type": "Square Fuse Box",
      "Compatible": "Tata LPT 1613TC, 1616TC, 2515TC, 2518TC, 3118TC, 3718TC, 4018TC, 4018 Horse",
      "Standards": "BS II / BS III / BS IV",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "square", "tata", "lpt", "bs-ii", "bs-iii", "bs-iv"],
    applications: ["Tata LPT Trucks", "Commercial Vehicles"],
  },
  {
    id: "fuse-box-eicher-canter",
    name: "Eicher Canter Fuse Box - Universal (BS II/III/IV)",
    slug: "fuse-box-eicher-canter-universal",
    category: "Fuse Boxes",
    subcategory: "Square Fuse Box",
    description: "Fuse box suitable for Eicher Canter 10.11 / 10.50 Pro / 10.59 / 10.69 / 10.75 / 10.90 / 10.95 / 11.10 / 30.25 Galaxy / Jumbo. Configuration: 30 wire + 20 point. BS II, BS III, BS IV compatible.",
    partNumber: "SFB5151C",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5151C.jpg",
    featured: true,
    specifications: {
      "Type": "Universal Fuse Box",
      "Compatible": "Eicher Canter 10.11, 10.50 Pro, 10.59, 10.69, 10.75, 10.90, 10.95, 11.10, 30.25 Galaxy, Jumbo",
      "Configuration": "30 Wire + 20 Point",
      "Standards": "BS II / BS III / BS IV",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "eicher", "canter", "universal", "bs-ii", "bs-iii", "bs-iv"],
    applications: ["Eicher Canter", "Light Commercial Vehicles"],
  },
  {
    id: "fuse-box-al-3116-3516",
    name: "Ashok Leyland 3116/3516/1616 Fuse Box - 4 Relay",
    slug: "fuse-box-al-3116-3516-4-relay",
    category: "Fuse Boxes",
    subcategory: "Square Fuse Box",
    description: "Fuse box suitable for Ashok Leyland 3116 / 3516 / 1616 with 4 relay configuration. 40 wire + 28 point.",
    partNumber: "SFB5181M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5181M.jpg",
    specifications: {
      "Type": "Square Fuse Box",
      "Compatible": "Ashok Leyland 3116, 3516, 1616",
      "Configuration": "40 Wire + 28 Point",
      "Relay Configuration": "4 Relay",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "ashok-leyland", "3116", "3516", "1616", "4-relay"],
    applications: ["Ashok Leyland", "Commercial Vehicles"],
  },
  {
    id: "fuse-box-al-4018-3116",
    name: "Ashok Leyland 4018/3116 Fuse Box - 3 Relay",
    slug: "fuse-box-al-4018-3116-3-relay",
    category: "Fuse Boxes",
    subcategory: "Square Fuse Box",
    description: "Fuse box suitable for Ashok Leyland 4018 / 3116. Configuration: 23 wire + 28 point + 3 relay (12 wire).",
    partNumber: "SFB5191M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5191M.jpg",
    specifications: {
      "Type": "Square Fuse Box",
      "Compatible": "Ashok Leyland 4018, 3116",
      "Configuration": "23 Wire + 28 Point",
      "Relay Configuration": "3 Relay (12 Wire)",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "ashok-leyland", "4018", "3116", "3-relay"],
    applications: ["Ashok Leyland", "Heavy Commercial Vehicles"],
  },
  {
    id: "fuse-box-al-4018-2214",
    name: "Ashok Leyland 4018/2214 Fuse Box - 5 Socket",
    slug: "fuse-box-al-4018-2214-5-socket",
    category: "Fuse Boxes",
    subcategory: "Square Fuse Box",
    description: "Fuse box suitable for Ashok Leyland 4018 / 2214. Configuration: 21 wire + 26 point with 5 socket.",
    partNumber: "SFB5196M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5196M.jpg",
    specifications: {
      "Type": "Square Fuse Box",
      "Compatible": "Ashok Leyland 4018, 2214",
      "Configuration": "21 Wire + 26 Point (With 5 Socket)",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "ashok-leyland", "4018", "2214", "5-socket"],
    applications: ["Ashok Leyland", "Heavy Trucks"],
  },
];

// MARUTI CAR TYPE FUSE BOXES
export const marutiFuseBoxCarProducts: Product[] = [
  {
    id: "fuse-box-maruti-car-type123-gypsy",
    name: "Maruti Car Type I/II/III Gypsy King Fuse Box",
    slug: "fuse-box-maruti-car-type-1-2-3-gypsy",
    category: "Fuse Boxes",
    subcategory: "Maruti Car Fuse Box",
    description: "Fuse box suitable for Maruti Car Type I, Type II, Type III, and Gypsy King. With flasher. Configuration: 17 wire, 18 point. Made with Saroop Deluxe Wire.",
    partNumber: "SFB5401M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5401M.jpg",
    featured: true,
    specifications: {
      "Type": "Car Fuse Box",
      "Compatible": "Maruti Car Type I, Type II, Type III, Gypsy King",
      "Configuration": "17 Wire, 18 Point",
      "Features": "With Flasher",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB6001M / SFB6005M / SFB6011M",
    },
    tags: ["fuse-box", "maruti", "car", "gypsy", "flasher"],
    applications: ["Maruti Cars", "Gypsy King"],
  },
  {
    id: "fuse-box-mahindra-bolero-camper",
    name: "Mahindra Bolero Camper MDI TC Fuse Box (BS II/III/IV)",
    slug: "fuse-box-mahindra-bolero-camper-mdi-tc",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Universal fuse box for Mahindra Bolero Camper MDI TC, BS II, BS III & BS IV. With flasher. Configuration: 18 wire, 24 point, 3 socket.",
    partNumber: "SFB5415M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5415M.jpg",
    featured: true,
    specifications: {
      "Type": "Universal Fuse Box",
      "Compatible": "Mahindra Bolero Camper MDI TC",
      "Configuration": "18 Wire, 24 Point, 3 Socket",
      "Standards": "BS II, BS III, BS IV",
      "Features": "With Flasher",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB6220M",
    },
    tags: ["fuse-box", "mahindra", "bolero", "camper", "bs-ii", "bs-iii", "bs-iv"],
    applications: ["Mahindra Bolero Camper", "Utility Vehicles"],
  },
  {
    id: "fuse-box-mahindra-jeep-bolero-pickup",
    name: "Mahindra Jeep/Bolero/Pick-up Utility Savari Fuse Box",
    slug: "fuse-box-mahindra-jeep-bolero-pickup",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Universal fuse box for Mahindra Jeep, Mahindra Bolero, Pick-up Utility Savari. BS II, BS III, BS IV compatible. Configuration: 17 wire, 24 point.",
    partNumber: "SFB5418M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5418M.jpg",
    specifications: {
      "Type": "Universal Fuse Box",
      "Compatible": "Mahindra Jeep, Mahindra Bolero, Pick-up Utility Savari",
      "Configuration": "17 Wire, 24 Point",
      "Standards": "BS II, BS III, BS IV",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB5608M",
    },
    tags: ["fuse-box", "mahindra", "jeep", "bolero", "pickup", "utility"],
    applications: ["Mahindra Jeep", "Mahindra Bolero", "Utility Vehicles"],
  },
  {
    id: "fuse-box-tata-sumo-407-709",
    name: "Tata Sumo/1613TC/2515TC/407/709/1109 Turbo Fuse Box",
    slug: "fuse-box-tata-sumo-407-709-1109",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Universal fuse box for Tata Sumo, Sumo Delux, Tata 1613 TC, 2515 TC, 2518 TC, 407, 709, 1109 Turbo. Configuration: 23 wire, 28 point.",
    partNumber: "SFB5422M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5422M.jpg",
    featured: true,
    specifications: {
      "Type": "Universal Fuse Box",
      "Compatible": "Tata Sumo, Sumo Delux, 1613TC, 2515TC, 2518TC, 407, 709, 1109 Turbo",
      "Configuration": "23 Wire, 28 Point",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB7130M / SFB5612M",
    },
    tags: ["fuse-box", "tata", "sumo", "407", "709", "1109", "turbo"],
    applications: ["Tata Sumo", "Tata 407", "Tata 709", "Tata 1109 Turbo"],
  },
  {
    id: "fuse-box-tata-sumo-207di",
    name: "Tata Sumo 207 DI/Spacio Fuse Box (BS II/III)",
    slug: "fuse-box-tata-sumo-207-di-spacio",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Universal fuse box for Tata Sumo 207 DI / 207 2005 DI / 207 DI Turbo / Sumo Spacio. BS II & BS III compatible. Configuration: 32 wire, 32 point, 2 Pcs AC fuse dibbi.",
    partNumber: "SFB5428M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5428M.jpg",
    featured: true,
    specifications: {
      "Type": "Universal Fuse Box",
      "Compatible": "Tata Sumo 207 DI, 207 2005 DI, 207 DI Turbo, Sumo Spacio",
      "Configuration": "32 Wire, 32 Point, 2 Pcs AC Fuse Dibbi",
      "Standards": "BS II, BS III",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB5201M / SFB5208M / SFB5601M",
    },
    tags: ["fuse-box", "tata", "sumo", "207-di", "spacio", "bs-ii", "bs-iii"],
    applications: ["Tata Sumo 207 DI", "Tata Sumo Spacio"],
  },
  {
    id: "fuse-box-tata-ace-magic",
    name: "Tata ACE/Magic Fuse Box (BS II/III/IV)",
    slug: "fuse-box-tata-ace-magic",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Fuse box suitable for Tata ACE and Magic. BS II, BS III & BS IV compatible. Configuration: 20 wire, 26 point.",
    partNumber: "SFB5432M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5432M.jpg",
    featured: true,
    specifications: {
      "Type": "Universal Fuse Box",
      "Compatible": "Tata ACE, Tata Magic",
      "Configuration": "20 Wire, 26 Point",
      "Standards": "BS II, BS III, BS IV",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB5206M",
    },
    tags: ["fuse-box", "tata", "ace", "magic", "bs-ii", "bs-iii", "bs-iv"],
    applications: ["Tata ACE", "Tata Magic", "Light Commercial Vehicles"],
  },
  {
    id: "fuse-box-farmtrac-60",
    name: "Farm Trac 60 Fuse Box with Jack",
    slug: "fuse-box-farmtrac-60",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Fuse box for Farm Trac 60. Configuration: 15 wire + 18 point, 2 Pcs Jack (8 pole 8 wire, 8 pole 7 wire).",
    partNumber: "SFB5436M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5436M.jpg",
    specifications: {
      "Type": "Universal Fuse Box",
      "Compatible": "Farm Trac 60",
      "Configuration": "15 Wire + 18 Point",
      "Jack": "2 Pcs Jack (8 Pole 8 Wire, 8 Pole 7 Wire)",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB6235M",
    },
    tags: ["fuse-box", "farmtrac", "tractor", "60"],
    applications: ["Farm Trac 60", "Agricultural Tractors"],
  },
  {
    id: "fuse-box-tractor-universal",
    name: "Tractor Universal Fuse Box (Mahindra/John Deere/Sonalika)",
    slug: "fuse-box-tractor-universal-mahindra-jd-sonalika",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Universal tractor fuse box for Mahindra Sarpanch, Arjun, John Deere, Sonalika. With flasher. Configuration: 27 wire, 28 point.",
    partNumber: "SFB5445M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5445M.jpg",
    featured: true,
    specifications: {
      "Type": "Universal Fuse Box",
      "Compatible": "Mahindra Sarpanch, Arjun, John Deere, Sonalika",
      "Configuration": "27 Wire, 28 Point",
      "Features": "With Flasher",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB7105 / SFB7115M / SFB7501M",
    },
    tags: ["fuse-box", "tractor", "mahindra", "john-deere", "sonalika", "universal"],
    applications: ["Mahindra Tractors", "John Deere", "Sonalika Tractors"],
  },
];

// MARUTI VAN TYPE & UNIVERSAL FUSE BOXES
export const marutiFuseBoxVanProducts: Product[] = [
  {
    id: "fuse-box-maruti-van-type123",
    name: "Maruti Van Type I/II/III Fuse Box with AC Fuse",
    slug: "fuse-box-maruti-van-type-1-2-3",
    category: "Fuse Boxes",
    subcategory: "Maruti Van Fuse Box",
    description: "Fuse box for Maruti Van Type I, Type II, Type III. With flasher and AC fuse. Configuration: 14 wire, 12 point.",
    partNumber: "SFB5501V",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5501V.jpg",
    featured: true,
    specifications: {
      "Type": "Van Fuse Box",
      "Compatible": "Maruti Van Type I, Type II, Type III",
      "Configuration": "14 Wire, 12 Point",
      "Features": "With Flasher, AC Fuse",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB8101V / SFB7524V / SFB6212V",
    },
    tags: ["fuse-box", "maruti", "van", "ac-fuse", "flasher"],
    applications: ["Maruti Van"],
  },
  {
    id: "fuse-box-mahindra-jeep-commander",
    name: "Mahindra Jeep Commander/Alfa/Eicher 380 Fuse Box",
    slug: "fuse-box-mahindra-jeep-commander-alfa",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Universal fuse box for Mahindra Jeep Commander, Alfa, Sarpanch, Bhoomiputra, Eicher 380, John Deere, APE (Type I, II, III). Configuration: 11 wire, 12 point.",
    partNumber: "SFB5512V",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5512V.jpg",
    specifications: {
      "Type": "Universal Fuse Box",
      "Compatible": "Mahindra Jeep Commander, Alfa, Sarpanch, Bhoomiputra, Eicher 380, John Deere, APE",
      "Configuration": "11 Wire, 12 Point",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB7125V / SFB7170V / SFB7401V",
    },
    tags: ["fuse-box", "mahindra", "commander", "alfa", "eicher", "john-deere", "ape"],
    applications: ["Mahindra Jeep", "Eicher 380", "APE 3-Wheeler"],
  },
  {
    id: "fuse-box-mahindra-bhumiputra-jcb",
    name: "Mahindra Bhumiputra JCB Type Maruti Van Fuse Box",
    slug: "fuse-box-mahindra-bhumiputra-jcb-maruti-van",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Fuse box for Mahindra Bhumiputra JCB type and Maruti Van. Configuration: 11 wire, 12 point. Also suitable for Sonalika Big / Farmtrack.",
    partNumber: "SFB5518V",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5518V.jpg",
    specifications: {
      "Type": "Universal Fuse Box",
      "Compatible": "Mahindra Bhumiputra JCB Type, Maruti Van, Sonalika Big, Farmtrack",
      "Configuration": "11 Wire, 12 Point",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB7205V / SFB7218V",
    },
    tags: ["fuse-box", "mahindra", "bhumiputra", "jcb", "maruti-van", "sonalika"],
    applications: ["Mahindra Bhumiputra", "Maruti Van", "Agricultural Vehicles"],
  },
  {
    id: "fuse-box-powertrac-farmtrac",
    name: "Power Trac 60/Farm Trac 35/45/60 Fuse Box with Jack",
    slug: "fuse-box-powertrac-farmtrac-35-45-60",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Fuse box for Power Trac 60, Farm Trac 35, 45, 60. Configuration: 12 wire, 12 point, 1 Pcs Jack (12 pole, 12 wire).",
    partNumber: "SFB5524V",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5524V.jpg",
    specifications: {
      "Type": "Universal Fuse Box",
      "Compatible": "Power Trac 60, Farm Trac 35, 45, 60",
      "Configuration": "12 Wire, 12 Point",
      "Jack": "1 Pcs Jack (12 Pole, 12 Wire)",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB7311",
    },
    tags: ["fuse-box", "powertrac", "farmtrac", "tractor"],
    applications: ["Power Trac", "Farm Trac Tractors"],
  },
  {
    id: "fuse-box-mf-tafe-241di",
    name: "Massy Ferguson Tafe 241DI Fuse Box with Single Socket",
    slug: "fuse-box-mf-tafe-241di",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Fuse box for Massy Ferguson Tafe 241DI with single socket. Configuration: 7 wire, 10 point.",
    partNumber: "SFB7205V",
    specifications: {
      "Type": "Universal Fuse Box",
      "Compatible": "Massy Ferguson Tafe 241DI",
      "Configuration": "7 Wire, 10 Point",
      "Features": "Single Socket",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB7150V / SFB7155V",
    },
    tags: ["fuse-box", "massy-ferguson", "tafe", "241di", "tractor"],
    applications: ["Massy Ferguson Tafe 241DI", "Agricultural Tractors"],
  },
];

// GLASS FUSE BOXES
export const glassFuseBoxProducts: Product[] = [
  {
    id: "fuse-box-glass-6pole",
    name: "Universal Glass Fuse Box - 6 Pole",
    slug: "universal-glass-fuse-box-6-pole",
    category: "Fuse Boxes",
    subcategory: "Glass Fuse Box",
    description: "Universal 6 pole glass fuse box. Made with Saroop Deluxe Wire.",
    partNumber: "SFB9106",
    image: "/products/fuse-boxes-complete/glass-fuse-box/SFB9106.jpg",
    specifications: {
      "Type": "Glass Fuse Box",
      "Poles": "6 Pole",
      "Application": "Universal",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "glass", "6-pole", "universal"],
    applications: ["Universal Vehicles", "Automotive"],
  },
  {
    id: "fuse-box-glass-8pole",
    name: "Universal Glass Fuse Box - 8 Pole",
    slug: "universal-glass-fuse-box-8-pole",
    category: "Fuse Boxes",
    subcategory: "Glass Fuse Box",
    description: "Universal 8 pole glass fuse box. Made with Saroop Deluxe Wire.",
    partNumber: "SFB9108",
    image: "/products/fuse-boxes-complete/glass-fuse-box/SFB9108.jpg",
    specifications: {
      "Type": "Glass Fuse Box",
      "Poles": "8 Pole",
      "Application": "Universal",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "glass", "8-pole", "universal"],
    applications: ["Universal Vehicles", "Automotive"],
  },
  {
    id: "fuse-box-glass-10pole",
    name: "Universal Glass Fuse Box - 10 Pole",
    slug: "universal-glass-fuse-box-10-pole",
    category: "Fuse Boxes",
    subcategory: "Glass Fuse Box",
    description: "Universal 10 pole glass fuse box. Made with Saroop Deluxe Wire.",
    partNumber: "SFB9110",
    image: "/products/fuse-boxes-complete/glass-fuse-box/SFB9110.jpg",
    specifications: {
      "Type": "Glass Fuse Box",
      "Poles": "10 Pole",
      "Application": "Universal",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "glass", "10-pole", "universal"],
    applications: ["Universal Vehicles", "Automotive"],
  },
  {
    id: "fuse-box-glass-12pole",
    name: "Universal Glass Fuse Box - 12 Pole",
    slug: "universal-glass-fuse-box-12-pole",
    category: "Fuse Boxes",
    subcategory: "Glass Fuse Box",
    description: "Universal 12 pole glass fuse box. Made with Saroop Deluxe Wire.",
    partNumber: "SFB9112",
    image: "/products/fuse-boxes-complete/glass-fuse-box/SFB9112.jpg",
    specifications: {
      "Type": "Glass Fuse Box",
      "Poles": "12 Pole",
      "Application": "Universal",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "glass", "12-pole", "universal"],
    applications: ["Universal Vehicles", "Automotive"],
  },
  {
    id: "fuse-box-glass-tata-407",
    name: "Tata 407 Glass Fuse Box - 24 Pole",
    slug: "glass-fuse-box-tata-407-24-pole",
    category: "Fuse Boxes",
    subcategory: "Glass Fuse Box",
    description: "Glass fuse box suitable for Tata 407. 24 pole configuration. Made with Saroop Deluxe Wire.",
    partNumber: "SFB9124",
    image: "/products/fuse-boxes-complete/glass-fuse-box/SFB9124.jpg",
    featured: true,
    specifications: {
      "Type": "Glass Fuse Box",
      "Poles": "24 Pole",
      "Compatible": "Tata 407",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "glass", "24-pole", "tata-407"],
    applications: ["Tata 407", "Commercial Vehicles"],
  },
];

// UNIVERSAL FUSE BOXES (WITH 60/80 AMPS FUSE)
export const universalFuseBoxProducts: Product[] = [
  {
    id: "fuse-box-tata-indica-60a-4wire",
    name: "Tata Indica Diesel Fuse Box - 60A (4 Wire)",
    slug: "fuse-box-tata-indica-60a-4-wire",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Universal Tata Indica Diesel fuse box with 60 AMPS fuse. Configuration: 4 wire with 8mm & 10mm deluxe wire.",
    partNumber: "SFB9001",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB9001.jpg",
    specifications: {
      "Type": "Universal Fuse Box",
      "Compatible": "Tata Indica Diesel",
      "Configuration": "4 Wire",
      "Fuse Rating": "60 AMPS",
      "Wire Gauge": "8mm, 10mm Deluxe",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "tata", "indica", "diesel", "60-amps"],
    applications: ["Tata Indica Diesel"],
  },
  {
    id: "fuse-box-tata-indica-60a-6point",
    name: "Tata Indica Diesel Fuse Box - 60A (4 Wire, 6 Point)",
    slug: "fuse-box-tata-indica-60a-6-point",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Universal Tata Indica Diesel fuse box with 60 AMPS fuse. Configuration: 4 wire, 6 point with 8mm & 10mm deluxe wire.",
    partNumber: "SFB9002",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB9002.jpg",
    specifications: {
      "Type": "Universal Fuse Box",
      "Compatible": "Tata Indica Diesel",
      "Configuration": "4 Wire, 6 Point",
      "Fuse Rating": "60 AMPS",
      "Wire Gauge": "8mm, 10mm Deluxe",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "tata", "indica", "diesel", "60-amps"],
    applications: ["Tata Indica Diesel"],
  },
  {
    id: "fuse-box-universal-60a-main-long",
    name: "Universal Fuse Box - 60A (Main Wire Long)",
    slug: "fuse-box-universal-60a-main-long",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Universal fuse box with 60 AMPS fuse. Main wire long configuration with 8mm & 10mm deluxe wire.",
    partNumber: "SFB9003",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB9003.jpg",
    specifications: {
      "Type": "Universal Fuse Box",
      "Fuse Rating": "60 AMPS",
      "Wire Gauge": "8mm, 10mm Deluxe",
      "Feature": "Main Wire Long",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB6201M",
    },
    tags: ["fuse-box", "universal", "60-amps", "main-wire-long"],
    applications: ["Universal Vehicles"],
  },
  {
    id: "fuse-box-universal-60a-long-6w-10p",
    name: "Universal Fuse Box - 60A Long (6 Wire, 10 Point)",
    slug: "fuse-box-universal-60a-long-6w-10p",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Universal fuse box with 60 AMPS fuse. Configuration: 6 wire, 10 point. Main wire long with 8mm & 10mm deluxe wire.",
    partNumber: "SFB9005",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB9005.jpg",
    specifications: {
      "Type": "Universal Fuse Box",
      "Configuration": "6 Wire, 10 Point",
      "Fuse Rating": "60 AMPS",
      "Wire Gauge": "8mm, 10mm Deluxe",
      "Feature": "Main Wire Long",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB6207M",
    },
    tags: ["fuse-box", "universal", "60-amps", "main-wire-long"],
    applications: ["Universal Vehicles"],
  },
  {
    id: "fuse-box-universal-60-80a",
    name: "Universal Fuse Box - 60A & 80A (Main Wire Long)",
    slug: "fuse-box-universal-60-80a",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Universal fuse box with both 60 AMPS & 80 AMPS fuse. Main wire long configuration with 8mm & 10mm deluxe wire.",
    partNumber: "SFB9007",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB9007.jpg",
    specifications: {
      "Type": "Universal Fuse Box",
      "Fuse Rating": "60 AMPS & 80 AMPS",
      "Wire Gauge": "8mm, 10mm Deluxe",
      "Feature": "Main Wire Long",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "universal", "60-amps", "80-amps"],
    applications: ["Universal Vehicles", "Heavy Duty"],
  },
  {
    id: "fuse-box-universal-60a-standard",
    name: "Universal Fuse Box - 60A Standard",
    slug: "fuse-box-universal-60a-standard",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Universal fuse box with 60 AMPS fuse. Standard configuration with 8mm & 10mm deluxe wire.",
    partNumber: "SFB9009",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB9009.jpg",
    specifications: {
      "Type": "Universal Fuse Box",
      "Fuse Rating": "60 AMPS",
      "Wire Gauge": "8mm, 10mm Deluxe",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "universal", "60-amps", "standard"],
    applications: ["Universal Vehicles"],
  },
  {
    id: "fuse-box-mahindra-maximo-mini",
    name: "Mahindra Maximo Mini Fuse Box",
    slug: "fuse-box-mahindra-maximo-mini",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Mini fuse box for Mahindra Maximo. Configuration: 46 wire with 5mm & 6mm deluxe wire.",
    partNumber: "SFB9012",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB9012.jpg",
    specifications: {
      "Type": "Mini Fuse Box",
      "Compatible": "Mahindra Maximo",
      "Configuration": "46 Wire",
      "Wire Gauge": "5mm, 6mm Deluxe",
      "Wire Type": "Saroop Deluxe Wire",
    },
    tags: ["fuse-box", "mahindra", "maximo", "mini"],
    applications: ["Mahindra Maximo", "3-Wheeler"],
  },
  {
    id: "fuse-box-mahindra-bolero-alto-mini",
    name: "Mahindra Bolero Camper/Alto Mini Fuse Box - 4 Relay",
    slug: "fuse-box-mahindra-bolero-alto-mini-4-relay",
    category: "Fuse Boxes",
    subcategory: "Universal Fuse Box",
    description: "Mini fuse box for Mahindra Bolero Camper MDI TC, Alto. BS II, BS III, BS IV compatible. Configuration: 55 wire, 40 point with 4 relay.",
    partNumber: "SFB9021",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB9021.jpg",
    featured: true,
    specifications: {
      "Type": "Mini Fuse Box",
      "Compatible": "Mahindra Bolero Camper MDI TC, Alto",
      "Configuration": "55 Wire, 40 Point",
      "Relay Configuration": "4 Relay",
      "Standards": "BS II, BS III, BS IV",
      "Wire Type": "Saroop Deluxe Wire",
      "Related": "SFB8501 / SFB5851",
    },
    tags: ["fuse-box", "mahindra", "bolero", "alto", "mini", "4-relay"],
    applications: ["Mahindra Bolero Camper", "Alto"],
  },
];
